import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import Panel from "./pages/panel/Panel";
import Login from "./pages/auth/Login";
import PrivateRoute from "./components/PrivetRoute";
import Signup from "./pages/auth/Signup";
import config from "./config.json";
import FastVisit from "./pages/auth/fastVisit/visit";
import FastVisitInfo from "./pages/auth/fastVisit/info";
import ResultPay from "./pages/auth/result";
import PaymentInfoPage from "./pages/auth/payment/info";
import PaymentAmountPage from "./pages/auth/payment/amount";
import TicketPage from "./pages/auth/ticket";
import TicketListPage from "./pages/auth/ticket/list";

function App() {
	return (
		<Router>
			<Switch>
				<PrivateRoute path="/panel" component={Panel} />
				<Route exact path="/" component={Login} />
				{config.disabled_register_page !== 1 && (
					<Route exact path="/signup" component={Signup} />
				)}
				<Route exact path="/result" component={ResultPay} />
				<Route exact path="/ticket" component={TicketPage} />
				<Route exact path="/ticket/list" component={TicketListPage} />
				<Route exact path="/payment/info" component={PaymentInfoPage} />
				<Route exact path="/payment/amount" component={PaymentAmountPage} />
				{config.disabled_fast_visit_page !== 1 && (
					<>
						<Route exact path="/visit/insert" component={FastVisit} />
						<Route exact path="/visit/info" component={FastVisitInfo} />
					</>
				)}

			</Switch>
		</Router>
	);
}

export default App;
